// 3rd party imports
import * as React from 'react';
import { useHistory } from 'react-router-dom';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { CaptchaStore } from 'stores';

// utils
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkErrorSummary } from 'uitk-react-error-summary';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';

export interface EmailProps {
  captcha?: CaptchaStore;
  email: string;
  l10n?: ILocalization;
  locale?: string;
  routeStore: RouteStore;
  sendVerificationEmail: (verificationEmail: string) => {};
  verificationEmailError?: string;
}

export const EmailDialog: React.FunctionComponent<EmailProps> = ({
  captcha,
  email,
  l10n,
  routeStore,
  locale,
  sendVerificationEmail,
  verificationEmailError,
}) => {
  const dialogId = 'email';
  const history = useHistory();

  React.useEffect(() => {
    history.push(`${routeStore.pathname}?${routeStore.mergeQueryString(routeStore.search, { pwaDialog: dialogId })}`);
  }, []);

  const onDismiss = () => {
    routeStore.closeDialog();
  };

  const navigateToLogin = () => {
    history.push(`/${modifyLocaleParam(locale)}/signin`);
  };

  const resendVerificationEmail = () => {
    sendVerificationEmail(email);
  };

  const successMessage = l10n.formatText('sign.up.success.message', email);

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogEmail" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            <UitkDialogContent>
              <UitkHeading tag="h3" size={5}>
                <LocalizedText message="sign.up.verification.email.sent" />
              </UitkHeading>
              {verificationEmailError && (
                <UitkSpacing margin={{ block: 'six' }}>
                  <div>
                    <UitkErrorSummary heading={verificationEmailError} />
                  </div>
                </UitkSpacing>
              )}
              <UitkText>{successMessage}</UitkText>
            </UitkDialogContent>

            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={false}
              buttonOne={{
                onClick: resendVerificationEmail,
                text: l10n.formatText('common.resend'),
                type: 'tertiary',
              }}
              buttonTwo={{
                onClick: navigateToLogin,
                text: l10n.formatText('sign.up.back.to.login'),
                type: 'primary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
